/* eslint-disable react/display-name */
import { LhChange } from "@liebherr/patternlib/dist/types/utils/interfaces";
import PLTextinput from "components/patternLib/form/PLTextinput";
import React from "react";
import { RuleValue } from "react-awesome-query-builder";

interface FieldProps {
  // field?: string;
  placeholder?: string;
  setValue?: (val: RuleValue) => void;
  value?: RuleValue;
}

export default ({ value, placeholder, setValue }: FieldProps) => {
  const handleChange = (event: CustomEvent<LhChange>) => {
    setValue?.(event.detail.value);
  };

  return (
    <PLTextinput value={value} lhChange={handleChange} size="small" showRemoveIcon={false} placeholder={placeholder} />
  );
};
